import IconHOC from '../IconHOC';

import { ReactComponent as ChevronDownIcon } from './chevronDown.svg';

export const ChevronDown = IconHOC(ChevronDownIcon);
